import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import StackCarousel from '../components/StackCarousel';
import WorkProcess from '../components/WorkProcess';
import FAQ from '../components/FAQ';
import About from '../components/About';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';

const deliveryStackItems = [
	{ name: 'React', category: 'Frontend', description: 'Declarative UI library for modern interfaces.', icon: '/tech-icons/react.svg' },
	{ name: 'Node.js', category: 'Backend', description: 'High-performance JavaScript runtime.', icon: '/tech-icons/nodejs.svg' },
	{ name: 'PostgreSQL', category: 'Data', description: 'Advanced relational database system.', icon: '/tech-icons/postgresql.svg' },
	{ name: 'MongoDB', category: 'Data', description: 'Flexible document-oriented database.', icon: '/tech-icons/mongodb.svg' },
	{ name: 'Docker', category: 'DevOps', description: 'Containerized deployment and packaging.', icon: '/tech-icons/docker.svg' },
	{ name: 'AWS', category: 'Cloud', description: 'Scalable infrastructure for production apps.', icon: '/tech-icons/aws.svg' },
];

const aiEcosystemItems = [
	{ name: 'OpenAI', category: 'LLM Platform', description: 'Large language models for intelligent workflows.', icon: '/tech-icons/openai.svg' },
	{ name: 'LangChain', category: 'Framework', description: 'Composable framework for AI application logic.', icon: '/tech-icons/langchain.png' },
	{ name: 'LlamaIndex', category: 'Framework', description: 'Data framework for retrieval pipelines.', icon: '/tech-icons/llamaindex.svg' },
	{ name: 'Qdrant', category: 'Vector DB', description: 'Vector search engine for semantic retrieval.', icon: '/tech-icons/qdrant.svg' },
	{ name: 'Pinecone', category: 'Vector DB', description: 'Managed vector infrastructure for AI search.', icon: '/tech-icons/pinecone.svg' },
	{ name: 'Hugging Face', category: 'Model Ecosystem', description: 'Open model and dataset ecosystem.', icon: '/tech-icons/huggingface.svg' },
];

function Home() {
	return (
		<div className="min-h-screen bg-gradient-to-b from-slate-50 via-slate-100 to-slate-100 text-slate-900">
			<Header />

			<main className="mx-auto max-w-7xl space-y-10 px-4 py-10 sm:space-y-12 sm:px-6 lg:px-8">
				<Hero />
				<Services />
				<StackCarousel
					id="delivery-stack"
					badge="Delivery Stack"
					title="Web & Mobile Engineering Stack"
					subtitle="Core frameworks, runtimes, and infrastructure powering resilient digital platforms."
					items={deliveryStackItems}
					chips={['⚡ Performance', '🔒 Security', '📈 Scalability', '📊 Observability', '🤖 Automation', '🛡️ Resilience']}
					accent="cyan"
				/>
				<StackCarousel
					id="ai-ecosystem"
					badge="AI Ecosystem"
					title="Modern Stack for Intelligent Products"
					subtitle="Unified view of AI platforms, frameworks, and vector infrastructure."
					items={aiEcosystemItems}
					chips={['📚 RAG Systems', '🤖 AI Agents', '📉 Latency Optimisation', '🧪 Prompt Engineering', '🔐 AI Governance']}
					accent="indigo"
				/>
				<WorkProcess />
				<About />
				<FAQ />
				<CallToAction />
			</main>

			<Footer />
		</div>
	);
}

export default Home;
